import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { supabase } from "../services/db";
import SelectComponent from "../components/Select";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import { scrapeSite } from "../services/scrape";
import {
  ThemedPrimaryButton,
  ThemedSecondaryButton,
} from "../components/Button/Button";

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 250,
  height: 250,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

function Previews(props) {
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
    },
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      acceptedFiles.length && props.onDrop(acceptedFiles[0]);
    },
  });
  const thumbs =
    files.length > 0 ? (
      files.map((file) => (
        <div style={thumb} key={file.name}>
          <div style={thumbInner}>
            <img
              src={file.preview}
              style={img}
              alt=""
              // Revoke data uri after image is loaded
              onLoad={() => {
                URL.revokeObjectURL(file.preview);
              }}
            />
          </div>
        </div>
      ))
    ) : (
      <div style={thumb}>
        <div style={thumbInner}>
          <img src={props.scrapedPreviewImg} style={img} alt="" />
        </div>
      </div>
    );

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <section className="dropzoneContainer">
      <div style={thumbsContainer}>{thumbs}</div>
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
    </section>
  );
}
const AddRecipe = ({ pageView, handleClose }) => {
  const { boardId } = useParams();
  const [boards, setBoards] = useState([]);
  const [imgSrc, setImgSrc] = useState();
  const [currentBoard, setCurrentBoard] = useState(boardId);
  const [currentSection, setCurrentSection] = useState();
  const [sections, setSections] = useState([]);
  const [numIngredients, setNumIngredients] = useState(1);
  const [numSteps, setNumSteps] = useState(1);
  const [formVisible, setFormVisible] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [recipeUrl, setRecipeUrl] = useState(
    // Default URL for testing
    "https://www.recipetineats.com/greek-chicken-gyros-with-tzatziki/#wprm-recipe-container-21826"
  );
  const [scrapedPreviewImg, setScrapedPreviewImg] = useState("");
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isLoading },
  } = useForm();
  const handleRecipeUrlChange = (event) => {
    setRecipeUrl(event.target.value);
  };
  const getScrapedData = async () => {
    setIsDataLoading(true);
    const response = await scrapeSite(recipeUrl);
    const responseData = await response.json();
    setFormVisible(true);
    setIsDataLoading(false);
    setNumIngredients(responseData?.ingredients.length);
    setNumSteps(responseData?.steps.length);
    reset({
      name: responseData?.title,
      description: responseData?.description,
      serves: responseData?.serves,
      author: responseData?.author,
      ingredients: responseData?.ingredients,
      steps: responseData?.steps.map((step) => step.description),
      recipeUrl,
    });
    setScrapedPreviewImg(responseData.imgSrc);
    return responseData;
  };

  const handleManualButtonClicked = () => {
    setFormVisible(true);
  };
  const onSubmit = async (data) => {
    const formattedIngredients = data.ingredients?.map((ingredient, i) => ({
      ...ingredient,
      position: i,
    }));

    const formattedSteps = data.steps?.map((step, i) => ({
      description: step,
      position: i,
    }));

    const { data: recipeData, error } = await supabase()
      .from("Recipe")
      .insert({
        name: data.name,
        description: data.description,
        imgSrc: imgSrc || scrapedPreviewImg || "",
        imgInDatabase: imgSrc ? true : false,
        ingredients: formattedIngredients,
        steps: formattedSteps,
        serves: data.serves,
        recipeUrl: data.recipeUrl,
        author: data.author,
      })
      .select()
      .single();

    if (error) {
      console.error("error", error);
      return;
    }
    if (currentSection) {
      const { error: secondError } = await supabase()
        .from("SectionRecipe")
        .insert({ SectionId: currentSection, RecipeId: recipeData.id });

      if (secondError) {
        console.error(secondError);
        return;
      }
    }
    pageView && navigate(-1);
    handleClose?.();
  };
  const handleImageUpload = async (file) => {
    const uuid = boards?.[0].user_id;
    const { data, error } = await supabase()
      .storage.from("recipe-images")
      .upload(`${uuid}/${file.name}`, file, {
        cacheControl: "3600",
        upsert: false,
      });
    if (!error) {
      setImgSrc(data.path);
    }
  };

  const handleAddIngredientClicked = () => {
    setNumIngredients(numIngredients + 1);
  };

  const handleAddStepClicked = () => {
    setNumSteps(numSteps + 1);
  };

  const getBoards = async () => {
    const { data } = await supabase().from("Boards").select();
    setBoards(data);
  };

  const getSections = async (currentBoardId) => {
    const { data } = await supabase()
      .from("Section")
      .select()
      .eq("boardId", currentBoardId);
    data && setSections(data);
  };

  const onBoardChange = (value) => {
    setCurrentBoard(value);
    getSections(value);
  };
  const onSectionChange = (value) => {
    setCurrentSection(value);
  };

  useEffect(() => {
    getBoards();
    if (currentBoard) {
      getSections(currentBoard);
    }
  }, [currentBoard]);

  const sectionItems = sections.map((section) => ({
    value: section.id,
    label: section.name,
  }));
  const resetForm = () => {
    reset();
    setFormVisible(false);
  };

  return (
    <div className={`${pageView === "route" && "whiteFont"}`}>
      {pageView === "route" && (
        <button onClick={() => navigate(-1)}>Back</button>
      )}
      {pageView === "route" && <h1>Add a recipe</h1>}

      {!formVisible ? (
        <div>
          <div className="flex">
            <label className="Label" htmlFor="recipeUrlPrefill">
              Prefill from url
            </label>
            <input
              id="recipeUrlPrefill"
              placeholder="Recipe Url"
              value={recipeUrl}
              onChange={handleRecipeUrlChange}
            />
            <ThemedPrimaryButton onClick={getScrapedData}>
              Prefill form
            </ThemedPrimaryButton>
          </div>
          <div>
            or Fill out manually
            <ThemedPrimaryButton onClick={handleManualButtonClicked}>
              Fill out manually
            </ThemedPrimaryButton>
          </div>
        </div>
      ) : (
        <ThemedPrimaryButton onClick={resetForm}>
          Reset form
        </ThemedPrimaryButton>
      )}
      {formVisible && !isDataLoading && (
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex">
              <div>
                <div>
                  <label className="Label" htmlFor="name">
                    Board Name
                  </label>

                  <SelectComponent
                    ariaLabel={"Board"}
                    placeholder={"Board"}
                    defaultValue={boardId}
                    items={boards.map((board) => ({
                      value: board.id,
                      label: board.name,
                    }))}
                    onValueChange={onBoardChange}
                  />
                </div>
                {(boardId || currentBoard) && (
                  <div>
                    <label className="Label" htmlFor="name">
                      Section Name
                    </label>

                    <SelectComponent
                      placeholder={"Section"}
                      ariaLabel={"Section"}
                      items={sectionItems}
                      onValueChange={onSectionChange}
                    />
                  </div>
                )}
                {/* register your input into the hook by invoking the "register" function */}
                <div>
                  <label className="Label" htmlFor="name">
                    Recipe Name
                  </label>
                  <textarea {...register("name", { required: true })} />
                  {errors.name && <span>This field is required</span>}
                </div>
                <div>
                  <label className="Label" htmlFor="author">
                    Author
                  </label>
                  <input {...register("author")} />
                </div>
                <div>
                  <label className="Label" htmlFor="description">
                    Recipe description
                  </label>
                  <textarea {...register("description", { required: true })} />
                  {errors.description && <span>This field is required</span>}
                </div>
                <div>
                  <label className="Label" htmlFor="recipeUrl">
                    Recipe URL
                  </label>
                  <input {...register("recipeUrl")} />
                </div>
                <div>
                  <label className="Label" htmlFor="serves">
                    Serves
                  </label>
                  <input
                    type="number"
                    {...register("serves", { required: true })}
                  />
                  {errors.serves && <span>This field is required</span>}
                </div>
                {[...Array(numIngredients).keys()].map((number) => (
                  <fieldset key={"ingredient" + number}>
                    <legend>Ingredient {number + 1}</legend>
                    <label htmlFor={`ingredients.${number}.name`}> Name </label>
                    <input {...register(`ingredients.${number}.name`)} />
                    <label>Amount</label>
                    <input
                      type="number"
                      step="any"
                      {...register(`ingredients.${number}.amount`)}
                    />
                    <label>Unit</label>
                    <input {...register(`ingredients.${number}.unit`)} />
                    <label>Note</label>
                    <input {...register(`ingredients.${number}.note`)} />
                  </fieldset>
                ))}
                <ThemedPrimaryButton onClick={handleAddIngredientClicked}>
                  Add ingredient
                </ThemedPrimaryButton>
                {[...Array(numSteps).keys()].map((number) => (
                  <fieldset key={"step" + number}>
                    <legend>Step {number + 1}</legend>
                    <label>Description</label>
                    <textarea
                      cols={60}
                      rows={6}
                      {...register(`steps.${number}`)}
                    />
                  </fieldset>
                ))}
                <ThemedPrimaryButton onClick={handleAddStepClicked}>
                  Add Step
                </ThemedPrimaryButton>
              </div>
              <Previews
                onDrop={handleImageUpload}
                scrapedPreviewImg={scrapedPreviewImg}
              />
            </div>

            {pageView === "route" ? (
              <button onClick={() => navigate(-1)}>Back</button>
            ) : (
              <ThemedSecondaryButton onClick={handleClose}>
                Cancel
              </ThemedSecondaryButton>
            )}
            <ThemedPrimaryButton disabled={isLoading} type="submit">
              Submit
            </ThemedPrimaryButton>
          </form>
        </div>
      )}
    </div>
  );
};
export default AddRecipe;
